module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "full-screen-container",
    on: {
      "click": _vm.toggleFullScreen
    }
  }, [_c('div', {
    staticClass: "icon",
    class: {
      activated: _vm.isFullScreen
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe702a4c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/map_module/maptool/toolbar/fullScreen.vue
// module id = 24
// module chunks = 0